namespace GeniuzPOS.PosShift {
    export class PsTaxInvoiceAddressColumns {
        static columnsKey = 'PosShift.PsTaxInvoiceAddress';
    }
}
